import { Grid, FormControl, Typography, Select, MenuItem } from "@mui/material";
import {
  IConditionsSectionProps,
  TFeeRule,
} from "../../interfaces/configuration";
import { GREATER_OR_EQUAL_THAN, FEE_RULES } from "../../utils/constants";
import { SimpleFormInput } from "../forms/SimpleFormInput";
import SectionWrapper from "./SectionWrapper";

const ConditionsSection = ({
  values,
  handleChangeValue,
  errors,
  baseInfo,
}: IConditionsSectionProps) => (
  <SectionWrapper title="Condiciones">
    <Grid item xs={6}>
      <FormControl fullWidth size="small">
        <Typography className="f-s-14 m-b-10">
          Precio total de la orden
        </Typography>
        <Select
          size="small"
          sx={{ fontSize: 14 }}
          value={values.orderPriceType || GREATER_OR_EQUAL_THAN}
          onChange={(e) =>
            handleChangeValue("orderPriceType", e.target.value as TFeeRule)
          }
        >
          {FEE_RULES.map(({ label, value }) => (
            <MenuItem key={value} value={value} sx={{ fontSize: 14 }}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={6}>
      <SimpleFormInput
        startAdornment="$"
        inputTitle=""
        placeholder="50000"
        valueName="orderPrice"
        errors={errors.orderPrice}
        {...baseInfo}
        autoFocus
      />
    </Grid>
    <Grid item xs={6}>
      <FormControl fullWidth size="small">
        <Typography className="f-s-14 m-b-10">
          Precio total del envío
        </Typography>
        <Select
          size="small"
          sx={{ fontSize: 14 }}
          value={values.deliveryPriceType || GREATER_OR_EQUAL_THAN}
          onChange={(e) =>
            handleChangeValue("deliveryPriceType", e.target.value as TFeeRule)
          }
        >
          {FEE_RULES.map(({ label, value }) => (
            <MenuItem key={value} value={value} sx={{ fontSize: 14 }}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={6}>
      <SimpleFormInput
        startAdornment="$"
        inputTitle=""
        placeholder="50000"
        valueName="deliveryPrice"
        errors={errors.deliveryPrice}
        {...baseInfo}
        autoFocus
      />
    </Grid>
    <Grid item xs={6}>
      <FormControl fullWidth size="small">
        <Typography className="f-s-14 m-b-10">Volumetría</Typography>
        <Select
          size="small"
          sx={{ fontSize: 14 }}
          value={values.weightType || GREATER_OR_EQUAL_THAN}
          onChange={(e) =>
            handleChangeValue("weightType", e.target.value as TFeeRule)
          }
        >
          {FEE_RULES.map(({ label, value }) => (
            <MenuItem key={value} value={value} sx={{ fontSize: 14 }}>
              {label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={6}>
      <SimpleFormInput
        inputTitle=""
        placeholder="Ej. 5"
        valueName="weight"
        errors={errors.weight}
        {...baseInfo}
        autoFocus
        endAdornment="Kg"
      />
    </Grid>
  </SectionWrapper>
);

export default ConditionsSection;
